<template>
  <div id="attribution">
    <div class="geo-poi_distribution panel panel-default">
      <div class="panel-heading">
        <h3>POI distribution
          <info-tooltip text="The Heat Map shows the POI distribution and density by geographical district.">
          </info-tooltip>
          <hr>
        </h3>
      </div>
      <div class="panel-body">
        <div>
          <button id="all-states" type="button" class="btn btn-primary" v-on:click="$refs.poiDistributionMap.reset();">View all</button>
        </div>
        <ul class="kpi-list">
          <li class="kpi-list__list_element">
            <span class="kpi-list__key">Total number of POIs:</span>
            <span class="kpi-list__value" v-if="raw_data">{{ raw_data.poisCount }}</span>
          </li>
          <li class="kpi-list__list_element">
            <span class="kpi-list__key">Covered geographical districts:</span>
            <span class="kpi-list__value" v-if="raw_data">{{ raw_data.numberOfReachedDistricts }}</span>
          </li>
        </ul>
        <div class="row map-table-container">
          <dc-map-table ref="poiDistributionMap"
               :tableCsv="poiMapTable.tableCsv"
               :mapJson="poiMapTable.mapJson"
               :name="poiMapTable.name"
               :columns="poiMapTable.columns"
               :tableClass="poiMapTable.class"
               :sortFunction="poiMapTable.sortFunction"
               :dimensionFunction="poiMapTable.dimensionFunction"
               :textDimensionFunction="poiMapTable.textDimensionFunction"
               :mapTitle="poiMapTable.mapTitle"
               @rowClicked="selectPoi"
               v-if="raw_data"> <!-- prevents places.csv to be loaded twice -->
          </dc-map-table>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
    </div>
    <div v-if="current_poi != null" v-show="mustShowPoi" class="overlay " style="display: block;">
      <div class="popup">
      <div class="inner">
        <div class="content">
          <button class="close" type="button" name="button" v-on:click="mustShowPoi=false"></button>
          <h2>{{current_poi.admin1}} - {{current_poi.address}}</h2>
          <v-map :zoom=16 :center="[current_poi.lat, current_poi.lon]">
            <v-tilelayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                         :attribution="attribution"></v-tilelayer>
            <v-marker :lat-lng="[current_poi.lat, current_poi.lon]"></v-marker>
            <v-icondefault :image-path="this.$chartSettings['image_path']"></v-icondefault>
          </v-map>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import DcMapTable from '../widgets/DcMapTable';
import InfoTooltip from '../widgets/InfoTooltip';
import Vue2Leaflet from 'vue2-leaflet';
import dc from 'dc';

let crossfilter = dc.crossfilter;

  export default {
    name: 'geographical-analysis',
    components: {
      DcMapTable,
      InfoTooltip,
      'v-map': Vue2Leaflet.Map,
      'v-tilelayer': Vue2Leaflet.TileLayer,
      'v-marker': Vue2Leaflet.Marker,
      'v-icondefault': Vue2Leaflet.IconDefault
    },
    data: function() {
      return {
        attribution: "&copy; <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
        current_poi : null,
        mustShowPoi : false,
        raw_data: null,
        poiMapTable: {
          tableCsv: "places.csv",
          mapJson: "map.json",
          name: "poi-distribution",
          class: "table cuebiq table-search animate clickable table",
          sortFunction: function(d) { return - d["id"]; },
          dimensionFunction: function(d) { return d["admin1"]; },
          textDimensionFunction: function(d) { return d["address"]; },
          mapTitle: function (d) {
            return d.key + "\nPlaces: " + (d.value || 0);
          },
          columns: [
            {
              label: 'Store',
              format: function(d) { return d["address"]; }
            }
          ]
        },
      }
    },
    mounted: function () {
      this.$cursorSpinner.processing = false;
      this.$nextTick(() => {
        this.fetchData();
        this.$_am.logEvent("visit",this.$route.name,"geo-analysis",new Date().toISOString())
      })
    },
    methods: {
      selectPoi: function(poi) {
        this.current_poi = poi;
        this.mustShowPoi = true;
      },
      fetchData: function () {
        var self = this;
        self.$dataStore.csv( "places.csv", function( places ) {
          var placesData = crossfilter(places);
          var provinces = placesData.dimension(dc.pluck("admin1"));

          self.raw_data = {
            poisCount: places.length,
            numberOfReachedDistricts: provinces.group().size()
          };

          self.$reportSettings.setVisibility();
        });
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "~leaflet/dist/leaflet.css";
</style>



// WEBPACK FOOTER //
// src/components/tabs/GeographicalAnalysis.vue